<template>
  <v-row>
    <v-col>
      <h2 class="pt-5">
        {{ title }}
        <slot name="suffix" />
      </h2>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';

@Component
export default class Subtitle extends Vue {
  @Prop() readonly title: string | TranslateResult | undefined;
}
</script>
